export default {
  base: {
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: '100px',
    backgroundColor: 'grey-05',
    fontFamily: 'base',
    display: 'flex',
    '&._spark_badge_small': {
      fontSize: 'xxxs',
      py: 'xxxs',
      px: 'xxs'
    },
    '&._spark_badge_medium': {
      fontSize: 'xxs',
      py: 'xxxs',
      px: 'xxs'
    },
    '&._spark_badge_large': {
      fontSize: 'base',
      py: 'xxs',
      px: 'xs'
    }
  },
  variants: {
    error: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'error-pink'
    },
    warning: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'primary-yellow-25'
    },
    success: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'greenPrimary25'
    },
    light: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'grey-0',
      borderColor: 'grey-20'
    },
    dark: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'primary',
      color: 'grey-0'
    },
    primary: {
      variant: 'spark.element.badge.base',
      backgroundColor: 'progress-bg'
    }
  }
};